import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Profile from '../../components/authenticated/account/profile/Profile'
import Billing from '../../components/authenticated/account/billing/Billing'
import { MyPaymentList } from '../../components/authenticated/account/billing/myPaymentList/MyPaymentList'
import { RefundPointList } from '../../components/authenticated/account/billing/refundPointList/RefundPointList'
import Password from '../../components/authenticated/account/password/Password'
import Preferences from '../../components/authenticated/account/preferences/Preferences'
import Notifications from '../../components/authenticated/account/notifications/Notifications'
import DeleteAccount from '../../components/authenticated/account/deleteAccount/DeleteAccount'
import TermsConsent from '../../components/authenticated/account/termsConsent/TermsConsent'
import { Card } from '../../components/card/Card'
import PageHeader from '../../components/ui/pageHeader/PageHeader'

import { useAuth } from '../../contexts/AuthContext'
import { useProfileContext } from '../../contexts/ProfileContext'
import { ACCOUNT_NAV_SECTIONS } from '../../constants/navigation'
import { AccountTab } from '../../types/account/account'
import { getFromToken, JwtKeys } from '../../utils/jwtUtils'

const Account = () => {
  const { authInfo } = useAuth()
  const { t } = useTranslation('account')
  const { tab: tabParam } = useParams<{ tab: string }>()

  const tab = Object.values(AccountTab).includes(tabParam as AccountTab)
    ? (tabParam as AccountTab)
    : AccountTab.PROFILE

  const { profile } = useProfileContext()

  const userEmail =
    getFromToken(authInfo?.accessToken ?? '', JwtKeys.EMAIL) ?? ''

  const renderTab = () => {
    switch (tab) {
      case AccountTab.PROFILE:
        return <Profile userEmail={userEmail} profile={profile} />
      case AccountTab.BILLING:
        return (
          <Card className="col-12">
            <Billing profile={profile} />
          </Card>
        )
      case AccountTab.PAYMENTS:
        return <MyPaymentList />
      case AccountTab.REFUNDS:
        return <RefundPointList />
      case AccountTab.PASSWORD:
        return <Password />
      case AccountTab.PREFERENCES:
        return <Preferences />
      case AccountTab.NOTIFICATIONS:
        return <Notifications profile={profile} />
      case AccountTab.TERMS:
        return (
          <Card className="col-12 responsive-half-card">
            <TermsConsent />
          </Card>
        )
      case AccountTab.DELETE_ACCOUNT:
        return <DeleteAccount />
    }
  }

  /** The menu section the page belongs to, named in the header eyebrow. */
  const section = ACCOUNT_NAV_SECTIONS.find(candidate =>
    candidate.items.some(item => item.path === `/account/${tab}`)
  )

  return (
    <div>
      <PageHeader
        title={{
          eyebrow: t('account.page-header.eyebrow', {
            section: section ? t(section.labelKey) : t('account.page-header.title'),
            email: userEmail,
          }),
          h1: t(`account.pages.${tab}.title`),
        }}
        sub={t(`account.pages.${tab}.subtitle`)}
      />
      {renderTab()}
    </div>
  )
}

export default Account
